<template>
<transition
@before-enter="beforeEnter"
@enter="enter"
@after-enter="afterEnter"
@before-leave="beforeLeave"
@leave="leave"
@after-leave="afterLeave"
>
<div v-show="isShow" class="c-loading">
  <div class="c-loading__logo">
    <img src="/special/tenkyu/10color/assets/img/common/logo.png" alt="" width="480" height="119">
  </div>
</div>
</transition>
</template>

<script>
import {gsap, Power3} from 'gsap/all';

export default {
  data() {
    return {
      raf: null,
    }
  },
  computed: {
    isFirstLoaded() {
      return this.$store.getters.isFirstLoaded;
    },
    isShow() {
      return this.$store.getters.isShowLoad;
    }
  },
  // watch: {
  //   $route(to, from) {},
  // },
  mounted() {
    this.checkFirstLoad();
  },
  methods: {
    checkFirstLoad() {
      // isLoadOpening: 動画読み込み完了
      // ほか初回にローディングしておく場合は追加
      if (this.$store.getters.isLoadOpening) {
        this.$store.commit('setFirstLoaded', true);
        gPG.rootHTML.classList.add('is-firstloaded');
        cancelAnimationFrame(this.raf);
        this.raf = null;
        this.loadEnd();
      } else {
        this.raf = requestAnimationFrame(this.checkFirstLoad);
      }
    },
    loadEnd() {
      this.$store.commit('setShowLoad', false);
    },

    // transition
    beforeEnter() {
    },
    enter(el, done) {
      gsap.fromTo(el, {
        autoAlpha: 0,
      }, {
        duration: 1.0,
        autoAlpha: 1,
        ease: Power3.easeIn,
        onComplete: () => {
          done();
        }
      });
    },
    afterEnter() {
    },

    beforeLeave() {},
    leave(el, done) {
      gsap.killTweensOf([el]);

      const tl = gsap.timeline({
        onComplete: () => {
          done();
        }
      });
      tl.to(el.querySelector('.c-loading__logo'), {
        duration: 1.0,
        autoAlpha: 0,
        ease: Power3.easeOut,
      })
      .to(el, {
        duration: 1.0,
        autoAlpha: 0,
        ease: Power3.easeOut,
      }, 0.8);

      // if (this.$route.name === 'index') {
      //   // TOP表示
      //   this.$store.commit('setShowTop', true);
      // } else {
      //   // POLO表示
      //   this.$store.commit('setShowPolo', true);
      // }
    },
    afterLeave() {
      if (this.$route.name === 'index') {
        // TOPスタート
        this.$store.commit('setStartTop', true);
      } else {
        // POLOスタート
        this.$store.commit('setStartPolo', true);
      }
    }
  }
}
</script>